<template>
  <b-field :label="label">
    <b-input type="text" placeholder="ニックネーム" v-model="nickname" />
  </b-field>
</template>

<script>
export default {
  name: 'NicknameTextField',
  props: {
    value: String,
    isHiddenRequiredSign: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    nickname: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
    label() {
      const label = 'ニックネーム';
      const requiredSign = '*';
      return `${label} ${this.isHiddenRequiredSign ? '' : requiredSign}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/profile-edit.scss';
</style>
